import React, { Component } from 'react'
import SlickSlider from 'react-slick'

import css from './style.module.css'

export default class Slider extends Component {


    componentDidMount(){
        window.addEventListener('touchstart', this.touchStart);
        window.addEventListener('touchmove', this.preventTouch, {passive: false});
    }
    
    componentWillUnmount(){
        window.removeEventListener('touchstart', this.touchStart);
        window.removeEventListener('touchmove', this.preventTouch, {passive: false});
    }
    
    touchStart(e){
        this.firstClientX = e.touches[0].clientX;
        this.firstClientY = e.touches[0].clientY;
    }
    
    preventTouch(e){
        const minValue = 5; // threshold
    
        this.clientX = e.touches[0].clientX - this.firstClientX;
        this.clientY = e.touches[0].clientY - this.firstClientY;
    
        // Vertical scrolling does not work when you start swiping horizontally.
        if(Math.abs(this.clientX) > minValue){ 
            e.preventDefault();
            e.returnValue = false;
            return false;
        }
    }
    
    config = {
        dots: true,
        infinite: false,
        slidesToScroll: 3,
        slidesToShow: 3,
        arrows:  false,
        centerMode: false,
        dotsClass: css.dots,
        accessibility: false,
        centerPadding: 0,
        responsive: [
            {
                breakpoint: 700,
                settings: {
                    dots: true,
                    draggable: true,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false
                }
            },
        ]
    }

    render() {
        const config = { ...this.config }

        const { items, children, light, ...props } = this.props

        if(items) {
            config.slidesToScroll = items
            config.slidesToShow = items
        }

        if(light)
            config.dotsClass = `${config.dotsClass} ${css.light}`

        return (
            <div className={css.slider} {...props}>
                <SlickSlider {...config}>
                    {children}
                </SlickSlider>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/v2SPRINTA/third-party/Slider/index.js